import { render, staticRenderFns } from "./ResponsiveResultTable.vue?vue&type=template&id=30c1f9ad&scoped=true&"
import script from "./ResponsiveResultTable.vue?vue&type=script&lang=js&"
export * from "./ResponsiveResultTable.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveResultTable.vue?vue&type=style&index=0&id=30c1f9ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1f9ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VSimpleTable})
